<script>
  import DadosCadastrais from './editar-meus-dados/DadosCadastrais'
  import EnderecoCobranca from './editar-meus-dados/EnderecoCobranca'
  import FormacaoEmprego from './editar-meus-dados/FormacaoEmprego'
  import NecessidadesEspeciais from './editar-meus-dados/NecessidadesEspeciais'

  import * as restfulService from '../../../../services/restfulService'

  import bus from '@utils/bus'
  import helpers from '@mixins/helper'

  import moment from 'moment'

  export default {
    components: {DadosCadastrais, EnderecoCobranca, FormacaoEmprego, NecessidadesEspeciais},
    mixins: [helpers],
    data () {
      return {
        tab: 'tab-dados-pessoais',
        carregandoDados: true,
        data: {
          pessoa: {
            nome: '',
            email: '',
            email_alternativo: '',
            cep: '',
            rua: '',
            numero: '',
            bairro: '',
            complemento: '',
            ref_cidade: ''
          },
          endereco_cobranca: {
            id: null,
            nome: '',
            cpf_cnpj: '',
            cep: '',
            rua: '',
            numero: '',
            bairro: '',
            complemento: '',
            ref_cidade: ''
          },
          pessoa_fisica: {
            dt_nascimento: '',
            dt_nascimento_formatada: '',
            fone_residencial: '',
            fone_celular: '',
            fone_profissional: '',
            fone_recado: '',
            tipo_sanguineo: '',
            ref_estado_civil: '',
            ref_raca: '',
            ref_naturalidade: '',
            ref_nacionalidade: '',
            nome_mae: '',
            cpf: '',
            rg_numero: '',
            sexo: ''
          }
        }
      }
    },
    computed: {
      menorDeIdade: function () {
        return moment().diff(moment(this.data.pessoa_fisica.dt_nascimento, 'YYYY-MM-DD'), 'years', false) < 18
      }
    },
    mounted () {
      this.buscarMeusDados()
      bus.$on('update-dt-nascimento', (value) => {
        this.data.pessoa_fisica.dt_nascimento = this.dateFormat(value, 'en')
      })
    },
    methods: {
      buscarMeusDados () {
        restfulService.get('pessoa', 'meus-dados')
          .then(response => {
            this.data.pessoa_fisica = {...this.data.pessoa_fisica, ...response.pessoa_fisica}
            this.data.endereco_cobranca = {...this.data.endereco_cobranca, ...response.endereco_cobranca}
            this.data.pessoa = {...this.data.pessoa, ...response}
            this.data.pessoa_fisica.dt_nascimento_formatada = this.dateFormat(this.data.pessoa_fisica.dt_nascimento, 'br')
            delete this.data.pessoa.pessoa_fisica
            delete this.data.pessoa.endereco_cobranca
            this.carregandoDados = false
            bus.$emit('hide-loader')
          })
          .catch(e => {
            this.carregandoDados = false
            bus.$emit('hide-loader')
            console.log(e)
          })
      }
    }
  }
</script>

<template>
    <div class="meu-perfil">
        <div v-if="!carregandoDados">
            <h2 class="meu-perfil-titulo">
                <i class="fas fa-user"></i>
                <span class="pl-2">Meus Dados</span>
            </h2>
            <v-tabs fixed-tabs
                    show-arrows
                    slot="extension"
                    v-model="tab"
                    slider-color="orange darken-3">
                <v-tab href="#tab-dados-pessoais">
                    <i class="fas fa-user"></i> <span class="pl-2">Dados Pessoais</span>
                </v-tab>
                <v-tab href="#tab-endereco-cobranca" v-if="menorDeIdade">
                    <i class="fas fa-file-invoice-dollar"></i> <span class="pl-2">Endereço de Cobrança</span>
                </v-tab>
                <v-tab href="#tab-formacao-empregos">
                    <i class="fas fa-briefcase"></i> <span class="pl-2">Formação / Experiências</span>
                </v-tab>
                <v-tab href="#tab-necessidades-especiais">
                    <i class="fas fa-universal-access"></i> <span class="pl-2">Necessidades Especiais</span>
                </v-tab>
            </v-tabs>
            <v-tabs-items v-model="tab">
                <v-tab-item id="tab-dados-pessoais">
                    <dados-cadastrais :dados="data"/>
                </v-tab-item>
                <v-tab-item id="tab-endereco-cobranca">
                    <endereco-cobranca :dados="data"/>
                </v-tab-item>
                <v-tab-item id="tab-formacao-empregos">
                    <formacao-emprego :dados="data"/>
                </v-tab-item>
                <v-tab-item id="tab-necessidades-especiais">
                    <necessidades-especiais :dados="data"/>
                </v-tab-item>
            </v-tabs-items>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// EditarMeusDados.vue?5b12a3cc